import React from 'react';
import ShoppingCartMvp from '.';
import { CrossSellProducts } from './CrossSellProducts';
import { GetFlag } from '../../../../utils/featureFlag';
import {
  FEATURE_FLAG_CROSS_SELL_TOP,
  FEATURE_FLAG_CROSS_SELL_VERTICAL,
  CROSS_SELL_VERTICAL_BREAKPOINT
} from '../../../../utils/cross-sell';
import useIsScreenSmallerThan from '../../../../hooks/useIsScreenSmallerThan';
import { WrapperContainer, CartContent } from './ShoppingCartWrapper.styles';

interface ShoppingCartWrapperProps {
  crossSellKey?: string;
  setCrossSellKey?: React.Dispatch<React.SetStateAction<string>>;
}

export const ShoppingCartWrapper: React.FC<ShoppingCartWrapperProps> = ({
  crossSellKey: externalCrossSellKey,
  setCrossSellKey: externalSetCrossSellKey
}) => {
  const [internalCrossSellKey, internalSetCrossSellKey] = React.useState('');

  // Use external (from LongSteelMvp) if provided, otherwise fallback to local state
  const crossSellKey = externalCrossSellKey ?? internalCrossSellKey;
  const setCrossSellKey = externalSetCrossSellKey ?? internalSetCrossSellKey;

  const crossSellTopFlag = GetFlag(FEATURE_FLAG_CROSS_SELL_TOP);
  const crossSellVerticalFlag = GetFlag(FEATURE_FLAG_CROSS_SELL_VERTICAL);
  const isSmallScreen = useIsScreenSmallerThan(CROSS_SELL_VERTICAL_BREAKPOINT);

  const showVertical = crossSellVerticalFlag && !isSmallScreen;
  const showHorizontal = !showVertical;

  // Módulo aparecerá apenas se houver produtos adicionados ao carrinho.
  // Apresentará até quatro produtos. Se não existirem quatro produtos (disponível e com preço), o módulo se ajustará escondendo os cards inexistentes.
  // Erro – Caso não exista nenhum produto para cross-sell ou haja erro ao trazê-los, o módulo (título e região dos cards) não deverá ser exibido. (sem exibir toast de error)
  // Durante o carregamento do carrinho, a área do cross-sell deverá carregar em paralelo (lazy loading).
  // Não deve existir produtos de cross-sell repetidos no carrinho do usuário e no módulo de cross-sell.

  return (
    <WrapperContainer>
      <CartContent>
        {showHorizontal && crossSellTopFlag && (
          <CrossSellProducts
            orientation="horizontal"
            setCrossSellKey={setCrossSellKey}
            title="Sugestões de compra para você"
          />
        )}
        <ShoppingCartMvp key={crossSellKey} crossSellKey={crossSellKey} />
        {showHorizontal && !crossSellTopFlag && (
          <CrossSellProducts
            orientation="horizontal"
            setCrossSellKey={setCrossSellKey}
            title="Sugestões de compra para você"
          />
        )}
      </CartContent>
    </WrapperContainer>
  );
};
